export default __webpack_public_path__ + "static/media/settings-placeholder.11c3e52d.jpg";